import { FlightGroupDeactivateGuard } from './../../flight_group/flight-group-guard.service';
import { IFlight } from './../flight';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChildren,
  AfterViewInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControlName, FormControl } from '@angular/forms';
import { CustomValidators } from '../../shared/custom-validators';
import { FlightGroupService } from '../../flight_group/flight-group.service';
import { LocationService } from '../../locations/location.service';
import { AircraftService } from '../../aircrafts/aircraft.service';
import { FlightService } from '../flight.service';
import { Helper } from '../../shared/helper';
import { IFlightGroup } from '../../flight_group/flight-group';
import { ILocation } from '../../locations/location';
import { IAircraft } from '../../aircrafts/aircraft';
import { Observable } from 'rxjs/Observable';
import { GenericValidator } from '../../shared/generic-validator';
import { THROW_IF_NOT_FOUND } from '../../../../node_modules/@angular/core/src/di/injector';

import * as moment from 'moment';

@Component({
  selector: 'app-bulk-edit',
  templateUrl: './bulk-edit.component.html',
  styleUrls: ['./bulk-edit.component.css']
})
export class BulkEditComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];

  flights: IFlight[];
  flightsForm: FormGroup;
  flightGroups: IFlightGroup[];
  locations: ILocation[];
  aircrafts: IAircraft[];
  displayMessages: { [key: string]: string } = {};
  asincFromDataResolve: any;
  asincFromData = new Promise((resolve, reject) => {
    this.asincFromDataResolve = resolve;
  });
  requestCountNum = 0;
  validationMessages = this.helper.getValidationMessages();
  private genericValidator: GenericValidator;
  timePattern = '([01][0-9]|2[0-3]):[0-5][0-9]$';
  disableForm = true;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private flightGroupService: FlightGroupService,
    private locationService: LocationService,
    private aircraftService: AircraftService,
    private flightService: FlightService,
    private helper: Helper
  ) {
    this.flightGroupService.getFlightGroups({}).subscribe(
      res => {
        this.flightGroups = res.body;
        this.requestCount();
      },
      error => {}
    );
    this.locationService.getLocations({}).subscribe(
      res => {
        this.locations = res.body;
        this.requestCount();
      },
      error => {}
    );
    this.aircraftService.getAircrafts({}).subscribe(
      res => {
        this.aircrafts = res.body;
        this.requestCount();
      },
      error => {}
    );
    this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit() {
    this.flightsForm = this.fb.group({
      id: [null]
    });
  }

  toggleField(e: any, field: string) {
    if (e.target.checked) {
      switch (field) {
        case 'time':
          this.flightsForm.addControl(
            'timeDate',
            new FormControl(
              [],
              [Validators.required, Validators.pattern(this.timePattern)]
            )
          );
          console.log(this.flightsForm);
          break;
        case 'date':
          this.flightsForm.addControl(
            'dateTime',
            new FormControl([], [Validators.required])
          );
          console.log(this.flightsForm);
          break;
        case 'priceFull':
        case 'priceChild':
          this.flightsForm.addControl(
            field,
            new FormControl([], [Validators.required, Validators.min(1)])
          );
          break;
        case 'priceInfant':
        case 'seatsTotal':
        case 'seatsOnlineTotal':
          this.flightsForm.addControl(
            field,
            new FormControl([], [Validators.required, Validators.min(0)])
          );
          break;
        default:
          this.flightsForm.addControl(
            field,
            new FormControl([], [Validators.required])
          );
          break;
      }
      this.setBulkValue(field);
    } else {
      if (field === 'time') {
        this.flightsForm.removeControl('timeDate');
        return;
      }
      if (field === 'date') {
        this.flightsForm.removeControl('dateTime');
        return;
      }
      this.flightsForm.removeControl(field);
    }
    this.flightsForm.updateValueAndValidity();
  }

  setBulkValue(field: string) {

    if (field === 'time' || field === 'date') {
      const dateTimeValue = this.flights[0]['flightDateTime'];
      const formatedDateTime = this.helper.getDateTime(dateTimeValue);

      if (field === 'time') {
        console.log(formatedDateTime);
        this.flightsForm.controls['timeDate'].setValue(formatedDateTime.time);
      }

      if (field === 'date') {
        console.log(formatedDateTime);
        this.flightsForm.controls['dateTime'].setValue(formatedDateTime.date);
      }

      return;
    }

    const value = this.flights[0][field];
    if (
      this.flights.find(obj => {
        return JSON.stringify(obj[field]) !== JSON.stringify(value);
      })
    ) {
      return;
    }

    if (value.id) {
      this.flightsForm.controls[field].setValue(value.id);
    } else {
      this.flightsForm.controls[field].setValue(value);
    }
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements.map(
      (formControl: ElementRef) =>
        Observable.fromEvent(formControl.nativeElement, 'blur')
    );

    Observable.merge(this.flightsForm.valueChanges, ...controlBlurs)
      .debounceTime(200)
      .subscribe(value => {
        this.displayMessages = this.genericValidator.processMessages(
          this.flightsForm
        );
      });
  }

  requestCount() {
    this.requestCountNum += 1;
    if (this.requestCountNum === 3) {
      setTimeout(() => {
        this.asincFromDataResolve();
        this.disableForm = false;
      }, 100);
    }
  }

  timePickAlone(e: any): void {
    const s = e.target.value;
    if (s.length === 2 && s.slice(-1) !== ':') {
      this.flightsForm.controls['timeDate'].setValue(s + ':');
    }
  }

  patchForm(formData: any) {
    this.asincFromData.then(() => {});
  }

  saveFlight() {
    this.disableForm = true;
    const formValue = this.flightsForm.value;
    if (formValue.dateTime && formValue.timeDate) {
      formValue.flightDateTime = this.helper.formatDateTime(formValue.dateTime, formValue.timeDate);
      delete formValue.dateTime;
      delete formValue.timeDate;
    }
    if (formValue.departure) {
      formValue.departure = '/locations/' + formValue.departure;
    }
    if (formValue.destination) {
      formValue.destination = '/locations/' + formValue.destination;
    }
    let count = 0;
    this.flights.forEach(flight => {
      formValue.id = flight.id;

      if (formValue.timeDate) {
        const dateObject = this.helper.getDateTime(flight.flightDateTime);
        formValue.flightDateTime = this.helper.formatDateTime(dateObject.date, formValue.timeDate);
      }

      if (formValue.dateTime) {
        const dateObject = this.helper.getDateTime(flight.flightDateTime);
        formValue.flightDateTime = this.helper.formatDateTime(formValue.dateTime, dateObject.time);
      }

      this.flightService.updateFlight(formValue).subscribe(res => {
        count++;
        if (count === this.flights.length) {
          this.activeModal.close(res);
        }
      }, (error: any) => {
        alert(JSON.stringify(error));
      });
    });
  }

  closeActiveModal() {
    if (this.flightsForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/flights/bulk-edit/bulk-edit.component.ts